(function () {
  // ─── CONFIG ───────────────────────────────────────────────
  const ROSEBANK_TAG = 'shop-rosebank';
  const HARARE_TAG  = 'shop-harare';
  // ──────────────────────────────────────────────────────────

  const storeMode = localStorage.getItem('store_mode') || 'rosebank';

  function getAvailability(tagsStr) {
    const tags = (tagsStr || '').toLowerCase();
    const hasRosebank = tags.includes(ROSEBANK_TAG);
    const hasHarare  = tags.includes(HARARE_TAG);

    // No store tags = available everywhere
    if (!hasRosebank && !hasHarare) return 'available';

    if (hasRosebank && hasHarare) return 'available';

    if (storeMode === 'rosebank' && hasRosebank) return 'available';
    if (storeMode === 'harare'  && hasHarare)  return 'available';

    // Not available in current store
    return storeMode === 'rosebank' ? 'harare-only' : 'rosebank-only';
  }

  function getLabel(availability) {
    if (availability === 'rosebank-only') return '🇿🇦 Available in Rosebank only';
    if (availability === 'harare-only')  return '🇿🇼 Available in Harare only';
    return null;
  }

function applyAvailability(card) {
    const tags         = card.dataset.tags || '';
    const availability = getAvailability(tags);
    const label        = getLabel(availability);

    const existing  = card.querySelector('.ss-store-badge');
    const chooseBtn = card.querySelector('.button, .card__footer .button');
    const buyNow    = card.querySelector('.shopify-payment-button, [data-shopify="payment-button"]');

    // Skip if already correct state
    if (existing && existing.textContent === label) return;
    if (!label && !existing && !card.classList.contains('ss-unavailable')) return;

    // ── Clean up previous state ───────────────────────────────
    card.classList.remove('ss-unavailable');
    if (existing) existing.remove();

    // Restore button
    if (chooseBtn && chooseBtn.dataset.originalText) {
      chooseBtn.textContent = chooseBtn.dataset.originalText;
      chooseBtn.style.pointerEvents = '';
      chooseBtn.style.opacity = '';
      chooseBtn.style.fontSize = '';
      chooseBtn.style.letterSpacing = '';
    }

    // Restore Buy it now
    if (buyNow) buyNow.style.display = '';

    if (!label) return;

    // ── Apply unavailable state ───────────────────────────────
    card.classList.add('ss-unavailable');

    // Badge
    const badge = document.createElement('div');
    badge.className = 'ss-store-badge';
    badge.setAttribute('aria-label', label);
    badge.textContent = label;
    card.style.position = 'relative';
    card.appendChild(badge);

    // Replace Choose options button
    if (chooseBtn) {
      if (!chooseBtn.dataset.originalText) {
        chooseBtn.dataset.originalText = chooseBtn.textContent.trim();
      }
      chooseBtn.textContent = label;
      chooseBtn.style.pointerEvents = 'none';
      chooseBtn.style.opacity = '0.6';
      chooseBtn.style.fontSize = '11px';
      chooseBtn.style.letterSpacing = '0.04em';
    }

    // Hide Buy it now
    if (buyNow) buyNow.style.display = 'none';
  }

  

  function processAllCards() {
    document.querySelectorAll('[data-tags]').forEach(applyAvailability);
  }

  // ── Disable Add to Cart on product page if unavailable ────
  function handleProductPage() {
    const tags = document.querySelector('[data-product-tags]');
    if (!tags) return;

    const availability = getAvailability(tags.dataset.productTags);
    if (availability === 'available') return;

    // Disable all add to cart / buy buttons
    const addBtns = document.querySelectorAll(
      '.product-form__submit, button[name="add"], [data-add-to-cart]'
    );

    addBtns.forEach(btn => {
      btn.disabled = true;
      btn.textContent = availability === 'rosebank-only'
        ? '🇿🇦 Available in Rosebank only'
        : '🇿🇼 Available in Harare only';
      btn.classList.add('ss-btn-unavailable');
    });

    // Insert a WhatsApp enquiry nudge below the button
    const formEl = document.querySelector('.product-form, .product__info-container');
    if (formEl && !formEl.querySelector('.ss-enquire-nudge')) {
      const nudge = document.createElement('p');
      nudge.className = 'ss-enquire-nudge';
      nudge.innerHTML = availability === 'rosebank-only'
        ? 'This item is available in our Rosebank store. <a href="https://api.whatsapp.com/send?phone=27820804632" target="_blank" rel="noopener">WhatsApp Rosebank →</a>'
        : 'This item is available in our Harare store. <a href="https://api.whatsapp.com/send?phone=27820804632" target="_blank" rel="noopener">WhatsApp Harare →</a>';
      formEl.appendChild(nudge);
    }
  }

  // ── Run ───────────────────────────────────────────────────
  processAllCards();
  handleProductPage();

  // Re-run on dynamic content (filters, pagination, quick-view)

// With this:

  let processing = false;
  const observer = new MutationObserver(function (mutations) {
    // Ignore mutations caused by our own badge insertions
    const isOwnMutation = mutations.every(m =>
      Array.from(m.addedNodes).every(n =>
        n.classList && (
          n.classList.contains('ss-store-badge') ||
          n.classList.contains('ss-enquire-nudge')
        )
      )
    );
    if (isOwnMutation || processing) return;

    processing = true;
    requestAnimationFrame(function () {
      processAllCards();
      processing = false;
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ── Harare: Replace checkout with WhatsApp on product page ──
  function handleHarareProductPage() {
    if (storeMode !== 'harare') return;

    // Only run on product pages
    if (!window.location.pathname.includes('/products/')) return;

    // const HARARE_WHATSAPP = '263781234567'; // ← update with real number

    // Get product details from the page
    const productTitle = document.querySelector('.product__title, h1.title')?.textContent.trim() || 'this item';
    const priceEl      = document.querySelector('.price-item--regular, .price-item');
    const productPrice = priceEl ? priceEl.textContent.trim() : '';
    const productUrl   = window.location.href;

    const message = encodeURIComponent(
      `Hi Suited Siren! I'd like to order:\n\n` +
      `*${productTitle}*\n` +
      `Price: ${productPrice}\n` +
      `Link: ${productUrl}\n\n` +
      `Please advise on availability and payment.`
    );

    const waUrl = `https://api.whatsapp.com/send?phone=27820804632&text=${message}`;

    // Build WhatsApp button
    const waBtn = document.createElement('a');
    waBtn.href      = waUrl;
    waBtn.target    = '_blank';
    waBtn.rel       = 'noopener';
    waBtn.className = 'ss-wa-order-btn';
    waBtn.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
      </svg>
      Order via WhatsApp
    `;

    // Find Add to Cart button and replace it
    const addToCartBtns = document.querySelectorAll(
      '.product-form__submit, button[name="add"], [data-add-to-cart]'
    );

    addToCartBtns.forEach(btn => {
      // Hide original button
      btn.style.display = 'none';

      // Insert WhatsApp button before it if not already added
      if (!btn.parentNode.querySelector('.ss-wa-order-btn')) {
        btn.parentNode.insertBefore(waBtn.cloneNode(true), btn);
      }
    });

    // Hide Buy it now
    const buyNow = document.querySelectorAll(
      '.shopify-payment-button, [data-shopify="payment-button"]'
    );
    buyNow.forEach(el => el.style.display = 'none');

    // Hide cart form quantity + submit area if visible
    const cartNote = document.querySelector('.product-form__error-message-wrapper');
    if (cartNote) cartNote.style.display = 'none';
  }

  handleHarareProductPage();

function handleHarareQuickAddModal(modal) {
    if (storeMode !== 'harare') return;
    if (modal.querySelector('.ss-wa-order-btn')) return; // already injected

    // const HARARE_WHATSAPP = '263781234567'; // ← your real number

    const productTitle = modal.querySelector('.product__title, h1, [class*="title"]')?.textContent.trim() || 'this item';
    const priceEl      = modal.querySelector('.price-item--regular, .price-item, .price');
    const productPrice = priceEl ? priceEl.textContent.trim() : '';
    const productLink  = modal.querySelector('a[href*="/products/"]');
    const productUrl   = productLink
      ? window.location.origin + productLink.getAttribute('href')
      : window.location.href;

    const message = encodeURIComponent(
      `Hi Suited Siren! I'd like to order:\n\n` +
      `*${productTitle}*\n` +
      `Price: ${productPrice}\n` +
      `Link: ${productUrl}\n\n` +
      `Please advise on availability and payment.`
    );

    const waUrl = `https://api.whatsapp.com/send?phone=27820804632&text=${message}`;

    // Hide Add to cart + Buy it now
    modal.querySelectorAll(
      '.product-form__submit, button[name="add"], [data-add-to-cart], .shopify-payment-button, [data-shopify="payment-button"]'
    ).forEach(el => el.style.display = 'none');

    // Build and inject WhatsApp button
    const waBtn = document.createElement('a');
    waBtn.href      = waUrl;
    waBtn.target    = '_blank';
    waBtn.rel       = 'noopener';
    waBtn.className = 'ss-wa-order-btn';
    waBtn.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
      </svg>
      Order via WhatsApp
    `;

    // Append after the product form
    const form = modal.querySelector('.product-form, form[action*="/cart"]');
    if (form) {
      form.appendChild(waBtn);
    } else {
      modal.appendChild(waBtn);
    }
  }

  // ── Harare: Watch for Quick Add modal content loading ─────
  if (storeMode === 'harare') {
    const modalObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          // Content loads into [id^="QuickAddInfo-"]
          const isQuickAddInfo = node.id && node.id.startsWith('QuickAddInfo-');
          const hasQuickAddInfo = node.querySelector && node.querySelector('[id^="QuickAddInfo-"]');

          const target = isQuickAddInfo ? node : (hasQuickAddInfo ? node.querySelector('[id^="QuickAddInfo-"]') : null);

          if (target && target.children.length > 0) {
            setTimeout(() => handleHarareQuickAddModal(target), 150);
            return;
          }

          // Also watch for children being added into existing QuickAddInfo divs
          if (mutation.target.id && mutation.target.id.startsWith('QuickAddInfo-') && mutation.target.children.length > 0) {
            setTimeout(() => handleHarareQuickAddModal(mutation.target), 150);
          }
        });
      });
    });

    modalObserver.observe(document.body, { childList: true, subtree: true });
  }

})();